export const blockIconsPhotoandimageAddPhotoAlternateNew = (
	<span className='material-symbols-outlined'>add_photo_alternate</span>
);
